document.addEventListener('turbolinks:load', () => {
  Array.from(document.querySelectorAll('button[data-bs-dismiss=alert]')).forEach((element) => {
    element.addEventListener('click', () => {
      const alert = element.closest('.alert')
      alert.parentNode.removeChild(alert)
    })
  })
})
